import { lazy } from 'react';
import { paths } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Login = lazy(() => import('@/pages/login/Login'));
const FindEmail = lazy(() => import('@/pages/find/email'));
const FindPassword = lazy(() => import('@/pages/find/password'));

// 비인증 사용자 라우트 (로그인, 계정찾기 등)
export const guestRoutes: TypedRouteObject = {
	children: [
		{
			path: paths.login.path,
			element: withSuspense(Login),
		},
		{
			path: paths.find.email.path,
			element: withSuspense(FindEmail),
		},
		{
			path: paths.find.password.path,
			element: withSuspense(FindPassword),
		},
		// 회원가입 - 아직 없는듯?
		// {
		// 	path: '/sign-up',
		// 	element: <SingUp />
		// },
	],
};
